export default "__VITE_PUBLIC_ASSET__b5121aa3__"